import { supabase } from "../admin/supabase";

/**
 * Generic CMS content collections.
 *
 * Every editable block that used to live in code (FAQs, campus tour stops,
 * schools, governance profiles, …) is mirrored into `content_items` so staff
 * can edit it from the admin dashboard. The original code data is still used
 * as a fallback whenever a collection is empty or the backend is unreachable,
 * so nothing can ever disappear from the public site.
 */
export async function getContentCollection(collection) {
  const { data, error } = await supabase
    .from("content_items")
    .select(
      "id, collection, item_key, title, subtitle, description, body, image_url, image_alt, icon, link_url, link_label, category, data, display_order"
    )
    .eq("collection", collection)
    .eq("published", true)
    .order("display_order", { ascending: true })
    .order("title", { ascending: true });

  if (error) throw error;
  return data || [];
}

export async function getContentCollections(collections) {
  const { data, error } = await supabase
    .from("content_items")
    .select(
      "id, collection, item_key, title, subtitle, description, body, image_url, image_alt, icon, link_url, link_label, category, data, display_order"
    )
    .in("collection", collections)
    .eq("published", true)
    .order("display_order", { ascending: true });

  if (error) throw error;
  return data || [];
}
